import { render, staticRenderFns } from "./BoardIcon.vue?vue&type=template&id=17a35fd4"
import script from "./BoardIcon.vue?vue&type=script&lang=js"
export * from "./BoardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports